import { Button, Row, notification } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useMutation } from "@apollo/client/react";

import { SingleOrderActionsWrapper } from "./SingleOrderActions.styled";
import { useMode } from "../../organisms";
import { UPDATE_ITEM, GET_ITEMS } from "../../../graphql/items";
import {
  getPayrollUpdateMutation,
  getPayrollListQueryName,
} from "../../../graphql/payroll";

export const SingleOrderActions: React.FC<{
  id: any;
  patch_url?: string;
}> = ({ id, patch_url }) => {
  const { mode, setMode, dataType } = useMode();
  const methods = useFormContext();

  const updateMutation = getPayrollUpdateMutation(dataType) ?? UPDATE_ITEM;
  const refetchQueryName = getPayrollListQueryName(dataType) ?? "Items";

  const [updateItem, { loading: isLoading }] = useMutation(updateMutation, {
    refetchQueries: [refetchQueryName],
    onCompleted: () => {
      notification.success({
        message: "Zapisano zmiany",
        style: {
          background: "#52c41a30",
        },
      });
      setMode("read");
    },
    onError: () => {
      notification.error({
        message: "Błąd zapisu danych",
        style: {
          background: "#ff4d4f30",
        },
      });
    },
  });

  const submit = () => {
    methods.handleSubmit((data) => {
      updateItem({ variables: { input: { id: Number(id), data } } });
    }, console.error)();
  };

  if (mode === "edit") {
    return (
      <Row
        justify="end"
        style={{
          height: "32px",
        }}
      >
        <SingleOrderActionsWrapper>
          <Button
            type="primary"
            disabled={isLoading}
            danger
            onClick={() => setMode("read")}
          >
            Anuluj
          </Button>
          <Button type="primary" onClick={submit} loading={isLoading}>
            Zapisz
          </Button>
        </SingleOrderActionsWrapper>
      </Row>
    );
  }

  return null;
};
